import { KeypadItem, KeypadEntryStatus } from './types'

export const isLoading = (items: KeypadItem[]): boolean =>
  items.filter(item => !!item.title).length < items.length

export const getKeypadStatus = (loading: boolean, items: KeypadItem[], failed?: boolean) => {
  if (loading) {
    return KeypadEntryStatus.Processing
  } else if (items.length === 0) {
    return failed ? KeypadEntryStatus.Failed : undefined
  }

  return undefined
}
